import React from 'react';
import { kbbBrand, atcBrand } from '../constants';
import Script from 'next/script';

export default ({ isKbb = false, elotLibraryUrl }) => (
    <>
        <Script
            type="module"
            src={elotLibraryUrl}
        />
        <dealer-lot
            data-cy="dealerLot"
            brand={isKbb ? kbbBrand : atcBrand}
            style={{ marginBottom: '40px' }}
        />
    </>
);
